import { d as e, c as t } from "../../../index-34b1f277.js";
import { RangeDatePickerAnatomy as a } from "./RangeDatePicker.anatomy.es.js";
const { defineMultiStyleConfig: o, definePartsStyle: r } = t(
  a.keys
), i = r({
  root: e({
    display: "flex",
    flexWrap: "wrap",
    gap: 2,
    "& > *": {
      flex: 1
    }
  })
}), f = o({
  baseStyle: i
});
export {
  f as RangeDatePicker
};
//# sourceMappingURL=RangeDatePicker.es.js.map
